mutation updateCompanyAddress($input: UpdateCompanyAddressInput!) {
  updateCompanyAddress(input: $input)
}
